var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgD20Crown = function SvgD20Crown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.902 5.064C5 8.11 6.66 7.164 7.884 2.224c.138-.557.134-.763.405-1.006.27-.244.711-.77.711 0v11.961H3.253c-.519-.757-.9-1.6-1.144-2.526-.243-.928-.487-2.46-.73-4.6l1.523-.99zm12.196 0c-2.078 3.078-3.739 2.132-4.982-2.84-.14-.556-.134-.763-.405-1.006-.27-.244-.711-.77-.711 0v11.961h5.747c.519-.757.9-1.6 1.144-2.526.243-.928.487-2.46.73-4.6l-1.523-.99z",
    fill: "#FFD900"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FAAD14",
    cx: 1.5,
    cy: 4.8,
    rx: 1.5,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FAAD14",
    cx: 9,
    cy: 1.6,
    rx: 1.5,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FAAD14",
    cx: 16.5,
    cy: 4.8,
    rx: 1.5,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12.8h12v1.533a.6.6 0 0 1-.6.6H3.6a.6.6 0 0 1-.6-.6V12.8z",
    fill: "#FAAD14"
  })))));
};
export default SvgD20Crown;